<template>
  <div>
    <footer class="main-footer row">
      <div class="col-12 col-lg-12 mx-auto container">
        <div class="row">
          <div class="col-lg-4 col-md-12 mx-auto">
            <ul class="navbar-nav w-100">
              <li>
                <router-link to="/" class="navbar-brand m-0 mr-auto">
                  <img
                    src="@/assets/images/logo-inbrands/inbrands-white.svg"
                    alt="Inbrands Logotipo"
                  />
                </router-link>
              </li>

              <li>
                <div class="social-network">
                  <p>Conheça mais sobre a InBrands:</p>
                  <a href="https://www.linkedin.com/company/inbrands/" target="_blank">
                    <img
                      src="@/assets/images/linkedin.png"
                      alt="Instagram"
                    />
                  </a>
                </div>
              </li>
            </ul>
          </div>

          <div class="col-lg-4 col-md-12 mx-auto">
            <div class="powered-container">
              <h4 class="powered-text">
                Powered by <span>99Jobs</span>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import FacebookIcon from "vue-material-design-icons/Facebook.vue";
import InstagramIcon from "vue-material-design-icons/Instagram.vue";
import LinkedinIcon from "vue-material-design-icons/Linkedin.vue";
import TwitterIcon from "vue-material-design-icons/Twitter.vue";
import PlayIcon from "vue-material-design-icons/Play.vue";

export default {
  name: "MainFooter",
  computed: {
    galeriaTimes() {
      return this.$store.state.teams;
    },
  },
  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    PlayIcon,
  },
};
</script>


<style lang="scss" scoped>
  .main-footer {

    background-color: #3D3D3D;
    padding: 80px 10px;
    .social-network {
      display: flex;
      align-items: center;
      gap: 30px;
      margin-top: 35px;
      p {
        font-size: 18px;
        font-weight: 400;
        line-height: initial;
        color: #fff;
        margin: 0;
      }
      a {
        img {
          width: 25px;
        }
      }
    }
    .powered-container {
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      @include media-breakpoint-down(md) {
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 50px;
      }
      .powered-text {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        text-transform: uppercase;
        color: #fff;
        margin: 0;
        span {
          font-weight: 700;
        }
      }
    }
  }
</style>
